import dayjs from 'dayjs';
import { Preset } from './types';

const startOfMonth = (d = dayjs()) => d.startOf('month');
const endOfMonth = (d = dayjs()) => d.endOf('month');
const today = () => dayjs().startOf('day');

export const DEFAULT_PRESETS: Preset[] = [
  {
    id: 'today',
    label: 'Today',
    getRange: () => [today(), today()],
  },
  {
    id: 'last7',
    label: 'Last 7 days',
    getRange: () => [today().subtract(6, 'day'), today()],
  },
  {
    id: 'last4weeks',
    label: 'Last 4 weeks',
    getRange: () => [today().subtract(27, 'day'), today()],
  },
  {
    id: 'thisMonth',
    label: 'This month',
    getRange: () => [startOfMonth(), endOfMonth()],
  },
  {
    id: 'lastMonth',
    label: 'Last month',
    getRange: () => {
      const m = startOfMonth(dayjs().subtract(1, 'month'));
      return [m, endOfMonth(m)];
    },
  },
  {
    id: 'quarter1',
    label: `Q1 - ${dayjs().year()}`,
    getRange: () => {
      const year = dayjs().year();
      return [
        dayjs(`${year}-01-01`).startOf('day'),
        dayjs(`${year}-03-31`).endOf('day'),
      ];
    },
  },
  {
    id: 'quarter2',
    label: `Q2 - ${dayjs().year()}`,
    getRange: () => {
      const year = dayjs().year();
      return [
        dayjs(`${year}-04-01`).startOf('day'),
        dayjs(`${year}-06-30`).endOf('day'),
      ];
    },
  },
  {
    id: 'quarter3',
    label: `Q3 - ${dayjs().year()}`,
    getRange: () => {
      const year = dayjs().year();
      return [
        dayjs(`${year}-07-01`).startOf('day'),
        dayjs(`${year}-09-30`).endOf('day'),
      ];
    },
  },
  {
    id: 'quarter4',
    label: `Q4 - ${dayjs().year()}`,
    getRange: () => {
      const year = dayjs().year();
      return [
        dayjs(`${year}-10-01`).startOf('day'),
        dayjs(`${year}-12-31`).endOf('day'),
      ];
    },
  },
];

export { startOfMonth, endOfMonth, today };
